import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { default as ScorecardItem } from "./ScorecardItem";
import * as dataActions from './redux/performance_metrics_grid_data_actions';

export class PerformanceMetricsDetailView extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      viewScorecard: null
    };

    this.closeDetailedView = this.closeDetailedView.bind(this);
    this.createScorecards = this.createScorecards.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    
    if(this.props.muIds !== nextProps.muIds) {
      if(nextProps.muIds) {
          let muIdString = nextProps.muIds.join(",");
          if(this.props.actions.fetchAgentScorecardsAction) {
            this.props.actions.fetchAgentScorecardsAction({ 
              managementUnitID: muIdString,
              scorecardUserTypeId: 2
          });
        }
      }
    }

    if(this.props.viewScorecard !== nextProps.viewScorecard) {

      if(nextProps.viewScorecard) {
        let itemId = nextProps.itemId;
        let itemType = nextProps.gridName;

        switch(itemType) {
          case "ManagementUnit":
            let requestParam = {
              customQueryParams: "&ids=" + itemId,
              groupingType: 1,
              isDetailView: true
            }
            if(this.props.actions.fetchCurrentWorkDayMUAction) {
              this.props.actions.fetchCurrentWorkDayMUAction(requestParam);
            }
            break;
          case "Team":
            let teamRequestParam = {
              customQueryParams: "&ids=" + itemId,
              groupingType: 2,
              isDetailView: true
            }
            if(this.props.actions.fetchCurrentWorkDayTeamAction) {
              this.props.actions.fetchCurrentWorkDayTeamAction(teamRequestParam);
            }
            break;
          case "Agent":
            let agentRequestParam = {
              customQueryParams: "&ids=" + itemId,
              groupingType: 3,
              isDetailView: true
            }
            if(this.props.actions.fetchCurrentWorkDayAgentAction) {
              this.props.actions.fetchCurrentWorkDayAgentAction(agentRequestParam);
            }
            break;
          default:
            break;
        }
      }

      this.setState({
        viewScorecard: nextProps.viewScorecard
      })
    }
  }

  createScorecards() {
    if(this.props.scorecards !== undefined && this.props.scorecards.length > 0) {
      let scorecardsRender = [];

      this.props.scorecards.forEach(c => {
          let scorecard = JSON.parse(JSON.stringify(c))
          let { gridName, itemId } = this.props;
          
          scorecardsRender.push(
            <ScorecardItem 
              key={c.scorecardId} 
              scorecard={scorecard} 
              groupID={gridName} 
              itemID={itemId} 
            />
          )
      })
      return scorecardsRender;
    }
  }

  closeDetailedView() {
    if(this.props.actions.closePerformanceMetricsDetailedView) {
      this.props.actions.closePerformanceMetricsDetailedView()
    }
  }
  
  render() {
    let { itemName, gridName } = this.props;
    return (
      <div>
        { this.state.viewScorecard ?
        <div className="performance__metrics-detail-view detail__view">
          <div className="detail__view-hdr">
            <div className="detail__view-desc">
              <span className="detail__view-type">{ gridName }</span>
              <span className="detail__view-name">{ itemName }</span>
            </div>
            <div className="detail__view-close" onClick={e => this.closeDetailedView(e)}></div>
          </div>
          <div className="scoreCard-wrapper">
            { this.createScorecards() }
          </div>
        </div>
      : null }
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    scorecards: state.scorecard.scorecards,
    muIds: state.scorecard.muIds,
    viewScorecard: state.scorecard.viewScorecard
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...dataActions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PerformanceMetricsDetailView);



// WEBPACK FOOTER //
// ./src/features/scorecard/PerformanceMetricsDetailView.js